<template>
  <div class="rc-grid-unit rc-grid-unit--skeleton">
    <div class="rc-thumbnail-wrapper mb-1">
      <div class="ratio ratio-16x9">
        <div class="rc-skeleton rc-skeleton-img rc-skeleton-animate-fade"></div>
      </div>
    </div>
    <div class="rc-grid-text">
      <div class="rc-sur-title">
        <div
          class="rc-skeleton rc-skeleton-text rc-skeleton-animate-wave bg-primary"
          style="width: 40%"
        ></div>
      </div>

      <div
        class="rc-skeleton rc-skeleton-text rc-skeleton-animate-wave bg-secondary"
        style="width: 60%"
      ></div>

      <div
        class="rc-skeleton rc-skeleton-text rc-skeleton-animate-wave bg-secondary"
        style="width: 50%"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RcGridSkeletonUnit'
}
</script>

<style lang="scss" scoped></style>
